var exports = {
  "x": "x61f99309--79e536--button",
};

module.exports = exports;
